import { Button, getTextStyles, styledOmitCustomProps } from '@braskai/ui-kit';

import { Box, css, Stack, styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

type STooltipProps = { hasHighlight?: boolean } & TooltipProps;

const TooltipBase = ({ className, hasHighlight: _hasHighlight, ...props }: STooltipProps) => (
  <Tooltip classes={{ popper: className }} {...props} />
);

export const STooltip = styled(TooltipBase)(
  ({ theme, hasHighlight }) => css`
    .${tooltipClasses.tooltip} {
      ${getTextStyles('body-2-md')};
      box-shadow: ${theme.customShadows.xl};
      margin: 0;
      padding: 0;
      background-color: ${theme.palette.common.white};
      color: ${theme.palette.common.black};

      border-radius: 16px;
      ${hasHighlight &&
      css`
        border: 1px solid ${theme.palette.primary[600]};
      `}
    }

    .${tooltipClasses.arrow} {
      color: ${theme.palette.common.white};

      &::before {
        border: 1px solid ${theme.palette.primary[600]};
        border-radius: 1px;
      }
    }

    ${theme.breakpoints.between('mobile', 'tablet')} {
      display: none;
    }
  `,
);

export const STooltipWrapper = styled(Stack)(
  () => css`
    gap: 8px;
    text-align: start;
  `,
);
export const STooltipTitle = styled(Box)(
  () => css`
    padding: 12px 12px 0px 12px;
  `,
);
export const STooltipContent = styled(Box)(
  () => css`
    align-self: center;
  `,
);
export const STooltipActions = styled(Stack)(
  () => css`
    flex-direction: row;
    align-self: flex-end;
    gap: 12px;
    padding: 0px 12px 8px 12px;
  `,
);

type ButtonProps = {
  $isLink?: boolean;
};

export const SButton = styled(
  Button,
  styledOmitCustomProps,
)<ButtonProps>(
  ({ theme, $isLink }) => css`
    ${getTextStyles('body-2-md')}
    color: ${$isLink ? theme.palette.grey[500] : theme.palette.primary[700]};
  `,
);
